import { Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";

// Lazy imports for pages
const LandingPage = lazy(() => import("../Pages/LandingPage"));
const AboutPage = lazy(() => import("../Pages/AboutUs"));
const ContactUs = lazy(() => import("@/Pages/ContactUs"));
const ProjectPage = lazy(() => import("@/Pages/ProjectPage"));
const ServicePage = lazy(() => import("@/Pages/ServicePage"));
const RequestQuotePage = lazy(() => import("@/Pages/RequestQuotePage"));
const AdminLogin = lazy(() => import("@/Pages/Admin/AdminLogin"));
const AdminDashboard = lazy(() => import("@/Pages/Admin/AdminDashboard"));
const SettingsPage = lazy(() => import("@/Pages/Admin/SettingsPage"));
const UsersPage = lazy(() => import("@/Pages/Admin/UsersPage"));
const ForgotPasswordPage = lazy(() => import("@/Pages/Admin/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("@/Pages/Admin/ResetPasswordPage"));
import ProtectedRoute from "@/components/ProtectedRoute";

export const RoutesContainer = () => {
  return (
    <Suspense fallback={<div className="p-8 text-center">Loading...</div>}>
      <Routes>
        {/* Home Route */}
        <Route path="/" element={<LandingPage />} />

        {/* Interior Design Services */}
        <Route path="/services" element={<ServicePage />} />

        {/* Request a Quote */}
        <Route path="/request-quote" element={<RequestQuotePage />} />

        {/* About & Company */}
        <Route path="/about" element={<AboutPage />} />
        <Route path="/projects" element={<ProjectPage />} />

        {/* Contact & Consultation */}
        <Route path="/contact" element={<ContactUs />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/settings" 
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/users" 
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          } 
        />

        {/* 404 Error Page */}
        <Route
          path="*"
          element={
            <div className="p-8 text-center">
              <h1 className="text-4xl font-bold text-gray-600">404</h1>
              <p className="text-xl text-gray-500">Page not found</p>
              <p className="mt-4">
                The page you're looking for doesn't exist.
              </p>
            </div>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default RoutesContainer;
